import { useSelector, TypedUseSelectorHook } from 'react-redux';
import { ApplicationRootState } from 'types';
const useTypedSelector: TypedUseSelectorHook<ApplicationRootState> =
  useSelector;
export default useTypedSelector;
